// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__20Ead","contentContainer":"styles_contentContainer__3veD0"};